import { requestHelpers } from '../../../../../helpers';

export const actions = {
    SET_PROFILE_SECTORS: "SET_PROFILE_SECTORS",
    GENERAL_SECTORS_REQUEST: "GENERAL_SECTORS_REQUEST",
    GENERAL_SECTORS_SUCCESS: "GENERAL_SECTORS_SUCCESS",
    GENERAL_SECTORS_ERROR: "GENERAL_SECTORS_ERROR",
}

export const setSectors= ( profile ) => {
    return {
        type: actions.SET_PROFILE_SECTORS,
        personId: profile.id,
        sectors: profile.sectors,
    }
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/sectors.js